var map = {
	"./amar.jpg": "8aae",
	"./amar.png": "ec25",
	"./andy.png": "bda5",
	"./lucy.png": "9724",
	"./paige.jpg": "363b",
	"./rishi.jpg": "0c5c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "86bf";